<template>
  <div class="content-left">
    <div class="title">
      <p>比亚迪</p>
      <p>智蛛AI经销商运营平台</p>
    </div>
    <div class="text">有“智”者，事竟成</div>
    <div class="downs-wrap">
      <div
        class="downs-wrap-item"
        @mousemove="mouseOver('ios')"
        @mouseleave="mouseLeave('ios')"
      >
        <img src="@/assets/img/IOS.png" alt />
        ios版
        <div class="pic-wrap" v-show="show.ios">
          <img src="@/assets/img/aniImgIos.png" alt />
        </div>
      </div>
      <div
        class="downs-wrap-item"
        @mousemove="mouseOver('android')"
        @mouseleave="mouseLeave('android')"
      >
        <img src="@/assets/img/ani.png" alt />安卓版
        <div class="pic-wrap" v-show="show.android">
          <img src="@/assets/img/aniImg.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ContentLeft",
  data() {
    return {
      show: {
        ios: false,
        android: false
      }
    }
  },
  methods: {
    mouseOver(type) {
      this.show[type] = true;
    },
    mouseLeave(type) {
      this.show[type] = false;
    },
  }
}
</script>

<style scoped>
.content-left {
  width: 400px;
  height: 400px;
  padding-top: 50px;
  box-sizing: border-box;
}

.title {
  font-size: 33px;
  font-family: PingFang-SC-Heavy, PingFang-SC;
  font-weight: 800;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
  margin-bottom: 40px;
}

.text {
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}

.downs-wrap {
  width: 330px;
  display: flex;
  margin-top: 40px;
  justify-content: space-between;
}

.downs-wrap > div {
  font-size: 18px;
  font-family: PingFang-SC-Heavy, PingFang-SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  width: 140px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.pic-wrap {
  position: absolute;
  width: 160px;
  height: 160px;
  border-radius: 10px;
  background-color: #fff;
  top: -170px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.pic-wrap > img {
  width: 160px;
}

.downs-wrap-item > img {
  width: 22px;
  margin-right: 7px;
}
</style>